import styled from 'styled-components';

export const Wrapper = styled.div`
  .header {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
  }
`;
